import type { TranslationDictionary } from "./types";

export const pt: TranslationDictionary = {
  // ── EmailGate ──
  "page.title": "Sua Proposta | Woba",
  "emailGate.placeholder": "seu@email.com",
  "emailGate.invalidEmail": "Por favor, insira um e-mail válido",
  "emailGate.blockedEmail":
    "Por favor, insira um e-mail corporativo ou pessoal válido",
  "emailGate.loading": "Carregando...",
  "emailGate.notFound": "Proposta não encontrada",
  "emailGate.loadError":
    "Não foi possível carregar a proposta. Verifique o link ou tente novamente.",
  "emailGate.retry": "Tentar Novamente",
  "emailGate.proposalLoadError": "Erro ao carregar proposta. Tente novamente.",

  // ── ProposalCoverScreen (tela 1) ──
  "cover.ctaLabel": "Ver minha proposta",
  "cover.talkToConsultant": "Falar com a {{name}}",
  "cover.scheduleNote.bold": "Proposta válida até {{date}}.",
  "cover.scheduleNote.rest":
    "Garanta seu escritório: agende uma visita presencial ou por vídeo.",
  "cover.toggle.traditional": "Locação tradicional",
  "cover.toggle.woba": "Woba",

  // ── ProposalContent ──
  "proposal.notFoundOrExpired": "Proposta não encontrada ou expirada.",

  // ── Stepper / navegação por etapas ──
  "steps.comparison": "Vantagem Woba",
  "steps.spaces.singular": "Espaço Selecionado",
  "steps.spaces.plural": "Espaços Selecionados",
  "steps.scheduling": "Agendar Visita",
  "steps.proposal": "Fazer Proposta",
  "steps.customOffice": "Escritório Sob Medida",
  "stepper.next": "Próximo: {{name}}",
  "nav.back": "Voltar",
  "nav.continue": "Continuar",
  "nav.requestVisit": "Solicitar visita",
  "nav.backToRoomsList": "Voltar para a lista de escritórios",

  // ── Hero copy (used by ProposalCoverScreen) ──
  "hero.subtitle":
    "Abandone as complexidades do modelo tradicional e centralize tudo em um único contrato inteligente.",
  "hero.emailPrompt":
    "Sua proposta está pronta, insira seu e-mail para acessar.",

  // ── Chat ──
  "chat.contextLabel": "Tirando dúvidas sobre",
  "chat.placeholder": "Pergunte sobre este espaço...",
  "chat.welcomeLine1":
    "Olá! 👋 Estou aqui para tirar suas dúvidas sobre o **{{spaceName}}**.",
  "chat.welcomePrice":
    "O valor desse espaço é de **R$ {{price}}/posição/mês**.",
  "chat.welcomeAskAnything":
    "Pergunte o que quiser sobre esse espaço — se eu não souber responder na hora, vamos consultar o parceiro e te retornamos.",
  "chat.errorMessage":
    "Desculpe, ocorreu um erro ao processar sua mensagem. Tente novamente.",
  "chat.dividerNowAbout": "Agora sobre: {{spaceName}}",
  "chat.sendAriaLabel": "Enviar",
  "chat.chip.monthlyValue": "Qual o valor mensal?",
  "chat.chip.parking": "Tem estacionamento?",
  "chat.chip.internet": "Qual a velocidade da internet?",
  "chat.chip.meetingRooms": "Salas de reunião inclusas?",
  "chat.chip.credits": "Como funcionam os créditos Woba?",
  "chat.chip.contract": "Qual a flexibilidade do contrato?",
  "chat.chip.scheduleVisit": "Quero agendar uma visita",

  // ── SpacesSection ──
  "spaces.selectedSpaces": "Espaços Selecionados",
  "spaces.optionsFor": "Opções para {{companyName}}",
  "spaces.optionsForDefault": "Opções para sua empresa",
  "spaces.bestOfficesInCity":
    "Selecionamos os melhores escritórios em {{city}} para a sua operação",
  "spaces.bestOptions": "Selecionamos as melhores opções para a sua operação",
  "spaces.availableOptions": "Opções Disponíveis",
  "spaces.recommended": "★ Recomendado",
  "spaces.combo": "Conjunto",
  "spaces.pos": "pos",
  "spaces.scopeOffice": "Escritório Privativo",
  "spaces.scopeSpace": "Área comum",
  "spaces.detail.roomId": "ID da sala",
  "spaces.detail.spaceId": "ID do espaço",
  "spaces.detail.back": "Voltar",
  "spaces.detail.close": "Fechar",
  "spaces.detail.expandPhotos": "Ver todas as fotos",
  "spaces.detail.officePhotosHeading": "Fotos do {{label}}",
  "spaces.detail.spacePhotosHeading": "Fotos da Área comum",
  "spaces.detail.positionsHeader": "Posições",
  "spaces.detail.sizeLabel": "Tamanho",
  "spaces.detail.pricePerPositionLabel": "Val. mensal / posição",
  "spaces.detail.summary":
    "Escritório privativo para operar com {{capacity}} posições e {{size}} m², no bairro {{neighborhood}} em {{city}}.",
  "spaces.detail.summaryNoSize":
    "Escritório privativo para operar com {{capacity}} posições, no bairro {{neighborhood}} em {{city}}.",
  "spaces.detail.summaryNoNeighborhood":
    "Escritório privativo para operar com {{capacity}} posições e {{size}} m², em {{city}}.",
  "spaces.detail.summaryNoSizeNoNeighborhood":
    "Escritório privativo para operar com {{capacity}} posições, em {{city}}.",
  "spaces.detail.summaryComboSuffix":
    " Este escritório faz parte de um conjunto de {{total}} escritórios reunidos para atender à sua solicitação completa.",
  "spaces.detail.spaceSummary":
    "A área comum do espaço conta com {{amenities}} comodidades disponíveis.",
  "spaces.detail.aboutOfficeTitle": "Sobre o escritório",
  "spaces.detail.aboutSpaceTitle": "Sobre a área comum",
  // Conformidade (PED-12757): documentos do prédio, nunca da sala — por isso
  // o tooltip nomeia o espaço como sujeito. Só estados positivos aparecem.
  "spaces.detail.complianceTitle": "Conformidade",
  "spaces.detail.complianceAvcb": "AVCB",
  "spaces.detail.complianceAvcbInfo":
    "Vistoria do Corpo de Bombeiros que atesta a segurança do prédio contra incêndio.",
  "spaces.detail.compliancePermit": "Alvará de funcionamento",
  "spaces.detail.compliancePermitInfo":
    "Licença da prefeitura que autoriza o funcionamento do prédio neste endereço.",
  "spaces.detail.amenitiesTitle": "Amenidades",
  "spaces.detail.amenitiesSubtitleOffice":
    "O que está disponível dentro do escritório privativo",
  "spaces.detail.amenitiesSubtitleSpace": "O que está disponível na área comum",
  "spaces.detail.locationTitle": "Localização",
  "spaces.tabNavLabel": "Navegação do espaço",
  "spaces.fullscreenTitle": "Localização dos Espaços",
  "spaces.mapButton": "Mostrar mapa",
  // Mapa mobile: o pino nomeia a sala igual ao card, e o chip de rodapé
  // substitui o antigo cabeçalho com seta como caminho de volta.
  "spaces.map.pinOffices": "{{count}} escritórios",
  "spaces.map.showList": "Mostrar lista",
  "spaces.viewMode.cards": "Ver em cards",
  "spaces.viewMode.list": "Ver em lista",
  "spaces.table.office": "Escritório",
  "spaces.table.monthlyValue": "Valor/mês",
  "spaces.table.pricePerPosition": "Custo/posição",
  "spaces.table.credits": "Diárias/mês",
  "spaces.table.creditBonusShort": "Ganhe {{credits}}",
  "spaces.mapLayers.button": "Pontos de interesse",
  "spaces.mapLayers.viewLabel": "Visualização",
  "spaces.mapLayers.view3d": "3D",
  "spaces.mapLayers.view2d": "2D",
  "spaces.mapLayers.poiLabel": "Pontos de interesse",
  "spaces.card.sqm": "{{value}} m²",
  "spaces.card.monthlyValue": "Valor mensal",
  "spaces.card.creditBonus": "Ganhe {{credits}} diárias/mês",
  "spaces.card.wantToVisit": "Selecionar",
  "spaces.card.selected": "Selecionado",
  "spaces.card.visitRequested": "Visita solicitada",
  "spaces.card.proposalSent": "Proposta enviada",
  "spaces.card.spaceHasAvcb": "Espaço com AVCB",
  "spaces.card.spaceHasPermit": "Espaço com alvará",
  "spaces.card.complianceTooltip":
    "O espaço onde esta sala está possui o documento",
  "spaces.card.viewDetails": "Ver detalhes",
  "spaces.card.spacePhoto": "Área comum",
  "spaces.card.comboRoomLabel": "Escritório {{number}}",
  "spaces.card.comboOfficesCount": "{{count}} escritórios",
  "spaces.card.detailsTitle": "Detalhes do espaço",
  "spaces.header.selectToVisit": "Escolha o espaço ideal",
  "spaces.header.title.singular": "1 Escritório Privativo",
  "spaces.header.title.plural": "{{count}} Escritórios Privativos",
  "spaces.header.title.filteredSingular":
    "{{count}} de {{total}} Escritório Privativo",
  "spaces.header.title.filteredPlural":
    "{{count}} de {{total}} Escritórios Privativos",
  "spaces.header.lead":
    "Cada opção passou pela curadoria Woba. Nenhuma por acaso.",
  "spaces.header.briefing.singular":
    "Escolhemos um Escritório Privativo para o seu pedido: {{details}}.",
  "spaces.header.briefing.plural":
    "Escolhemos alguns Escritórios Privativos para o seu pedido: {{details}}.",
  "spaces.header.briefing.inCity": "em {{city}}",
  "spaces.header.briefing.positionsExact": "{{count}} posições",
  "spaces.header.briefing.contract": "contrato de {{months}} meses",
  "spaces.filters.sortBy": "Ordenar por",
  "spaces.filters.sortRecommended": "Recomendado",
  "spaces.filters.sortCheapest": "Mais barato",
  "spaces.filters.sortMostPositions": "Mais posições",
  "spaces.filters.capacity": "Capacidade",
  "spaces.filters.priceRange": "Faixa de preço",
  "spaces.filters.size": "Tamanho",
  "spaces.filters.capacityUpTo": "Até {{max}} posições",
  "spaces.filters.capacityBetween": "{{min}} a {{max}} posições",
  "spaces.filters.capacityAbove": "Mais de {{min}} posições",
  "spaces.filters.priceUpTo": "Até R$ {{max}}",
  "spaces.filters.priceBetween": "R$ {{min}} a R$ {{max}}",
  "spaces.filters.priceAbove": "Acima de R$ {{min}}",
  "spaces.filters.sizeUpTo": "Até {{max}} m²",
  "spaces.filters.sizeBetween": "{{min}} a {{max}} m²",
  "spaces.filters.sizeAbove": "Mais de {{min}} m²",
  "spaces.filters.noResults": "Nenhum espaço encontrado com esses filtros.",
  "spaces.selectedBar.hintEmpty": "Selecione um espaço para continuar",
  "spaces.selectedBar.hintSelected": "Escolha como deseja prosseguir",

  // ── PhotosTab ──
  "photos.prevPhoto": "Foto anterior",
  "photos.nextPhoto": "Próxima foto",
  "photos.noImage": "Sem imagem disponível",
  "photos.didYouLike": "Gostou?",
  "photos.liked": "Gostei",
  "photos.disliked": "Não gostei",
  "photos.positions": "posições",
  "photos.perPosition": "R$ {{price}} / posição",
  "photos.priceOnRequest": "Valor sob consulta",
  "photos.licenseFee": "License Fee R$ {{price}}",
  "photos.licenseFeeIncluded": "License Fee incluso",

  // ── AmenitiesTab ──
  "amenities.notAvailable": "Informações de amenidades não disponíveis.",
  "amenities.showOthers": "Outras ({{count}})",
  "amenities.showLess": "Ver menos",

  // ── RoomEmbeddedMap (distance calculator) ──
  "map.calculateDistance": "Calcular distância entre o espaço e...",
  "map.placeholder": "Ex: Av. Paulista, 1000",
  "map.searching": "Buscando...",
  "map.calculate": "Calcular",
  "map.distancesFrom": "Distâncias a partir de",
  "map.addressNotProvided": "Endereço não informado",
  "map.selectedNoAddress": "Endereço não informado para esta opção",
  "map.recenter": "Recentralizar",
  "map.recenterTitle": "Recentralizar mapa",
  "map.clickToInteract": "Clique para interagir com o mapa",
  "map.locationNotFound":
    "Não encontramos esse endereço. Tente buscar de outra forma.",
  "advantages.goToSlide": "Ir para o destaque {{n}}",
  "visitDialog.title": "Agendar visitas",
  "visitDialog.description":
    "Neste momento, seriam enviadas comunicações para os Parceiros selecionados, verificando a disponibilidade da visita às suas salas.",
  "poi.noDescription": "Sem descrição",

  // ── ComparisonSection ──
  "comparison.heading":
    "A forma *mais inteligente* de contratar e administrar escritórios",

  // ── ComparisonSection (conteúdo "Vantagem Woba") ──
  "advantage.heading": "Ter um escritório *pode ser fácil*.",
  "advantage.subheadingPre": "Com a Woba, você tem acesso a",
  "advantage.subheadingBold": "muito mais do que um escritório",
  "advantage.subheadingPost":
    ": tudo simples, prático e sem burocracia. E sem pagar nada a mais por isso.",
  "advantage.cardsAriaLabel": "Vantagens Woba",
  "advantage.card1.title": "Melhor preço garantido",
  "advantage.card1.descPre": "Com a Woba,",
  "advantage.card1.descBold": "pague o mesmo valor mensal",
  "advantage.card1.descPost":
    "que pagaria direto com o parceiro, com até 15% de desconto negociado — e ainda leve toda a rede.",
  "advantage.card1.sealAlt": "Selo de melhor preço garantido",
  "advantage.card1.tagline":
    "Achou preço melhor, dentro ou fora da rede? A gente cobre.",
  "advantage.card2.title": "Muito além de um escritório",
  "advantage.card2.stat": "3.000+ espaços · 400+ cidades",
  "advantage.card2.descPre": "Seu time com acesso a",
  "advantage.card2.descBold": "salas de reunião e diárias em coworking",
  "advantage.card2.descPost":
    "em mais de 3.000 espaços da Rede Woba em todo o Brasil, sem pagar nada a mais por isso.",
  "advantage.card2.badge": "Ganhe horas para uso na rede",
  "advantage.card3.title": "Seu time de facilities com super poderes",
  "advantage.card3.descPre": "Uma equipe de",
  "advantage.card3.descBold": "agentes de IA",
  "advantage.card3.descPost":
    "cuida da sua operação — acessos, reservas, manutenção e contratos — tudo resolvido num boleto só, sem burocracia.",
  "advantage.card4.title": "Escritório como serviço",
  "advantage.card4.descBold": "A flexibilidade que você precisa:",
  "advantage.card4.descPost":
    "aumente, reduza ou mude de cidade quando o negócio pedir. Sem multa, sem CAPEX, sem obra, sem contrato longo.",

  // ── CostBreakdownDrawer ("Entenda o preço" badge no card) ──
  "costBreakdown.badge": "Entenda o preço",
  "costBreakdown.badgeWithScope": "Entenda o preço - {{scope}}",
  "costBreakdown.drawerTitle": "Tudo isso, num boleto só.",
  "costBreakdown.drawerSubtitle": "Seu time cuida do negócio, não do prédio.",
  "costBreakdown.compositionTitle": "Como funciona a sua locação na Woba",
  "costBreakdown.compositionBodyPre":
    "Essa mensalidade é formada por 3 grupos de custo, os mesmos de uma locação tradicional. Aqui, eles se juntam em um valor único, com uma única data de vencimento, sem planilha para conciliar.",
  "costBreakdown.compositionBodyBold": "Tudo isso, em um boleto só.",
  "costBreakdown.totalLabel": "Total mensal",
  "costBreakdown.detailTitle": "Como funciona uma locação tradicional",
  "costBreakdown.footnotePre":
    "Numa locação tradicional, seu boleto mensal se divide em 3 grandes grupos. Esses grupos têm diversos itens dentro, o que resulta em {{count}} itens para gerenciar: {{count}} fornecedores, {{count}} contratos, cada um com sua própria data de vencimento e seu próprio ponto de contato. No fim, é o seu time que carrega esse peso todo mês.",
  "costBreakdown.category.rent": "Aluguel + Condomínio + IPTU",
  "costBreakdown.category.services": "Serviços Operacionais",
  "costBreakdown.category.support": "Suporte e Depreciação",
  "costBreakdown.item.rentBase": "Aluguel base",
  "costBreakdown.item.condo": "Condomínio",
  "costBreakdown.item.iptu": "IPTU",
  "costBreakdown.item.energy": "Energia",
  "costBreakdown.item.staff": "Staff operacional",
  "costBreakdown.item.cleaning": "Limpeza",
  "costBreakdown.item.internet": "Internet / Telecom",
  "costBreakdown.item.maintenance": "Manutenção",
  "costBreakdown.item.water": "Água",
  "costBreakdown.item.furniture": "Mobiliário (depreciação)",
  "costBreakdown.item.amenities": "Café / Amenities",
  "costBreakdown.item.insurance": "Seguros",
  "costBreakdown.item.admin": "Admin / Overhead",

  // ── CTASection / Footer ──
  "cta.tagline":
    "A forma mais inteligente de contratar e administrar escritórios",
  "cta.contact": "Contato",
  "cta.proposal": "Proposta",
  "cta.validUntil": "Válida até:",
  "cta.validTBD": "A definir",
  "cta.copyright": "© {{year}} Woba. Todos os direitos reservados.",

  // ── Logos marquee (ProposalCoverScreen footer) ──
  "logos.socialProof": "Faça como milhares de empresas que confiam na Woba",

  // ── VisitSchedulingStep ──
  "schedule.overline": "Agende sua visita",
  "schedule.title": "Você *escolhe* como quer conhecer.",
  "schedule.subtitle":
    "Quanto mais a fundo você for, mais entende como a Woba funciona na prática — e quanto ela economiza para a {{companyName}}.",
  "schedule.subtitleNoCompany":
    "Quanto mais a fundo você for, mais entende como a Woba funciona na prática — e quanto ela pode economizar para você.",
  "schedule.instruction":
    "Escolha o dia, o horário e o formato da visita para cada espaço.",
  "schedule.dateTimeLabel": "Dia e horário",
  "schedule.previousDates": "Dias anteriores",
  "schedule.nextDates": "Próximos dias",
  "schedule.modalityLabel": "Formato da visita",
  "schedule.modalityInPerson": "Presencial",
  "schedule.modalityOnline": "Videochamada",
  "schedule.modalityTestDrive": "Test-drive",
  "schedule.modalityExplainerInPerson":
    "Real e de perto. Conheça o espaço pessoalmente, veja a estrutura de perto e sinta como seria a rotina do seu time ali.",
  "schedule.modalityExplainerOnline":
    "Prático e imediato. Agende uma visita por videochamada para conhecer o escritório e tirar dúvidas direto com o espaço.",
  "schedule.modalityExplainerTestDrive":
    "Completo, sem pressa. Use o escritório por um dia inteiro com sua equipe antes de decidir, sem custo.",
  "schedule.testDriveLearnMore": "Saiba mais",
  "schedule.testDriveDrawerTitle": "Test-drive de 1 dia",
  "schedule.testDriveDrawerSubtitle":
    "Completo, sem pressa. Use o escritório por um dia inteiro com sua equipe antes de decidir, sem custo.*",
  "schedule.testDriveDrawerPhotoAlt":
    "Time trabalhando em um espaço compartilhado da Woba",
  "schedule.testDriveHowItWorksTitle": "Como funciona",
  "schedule.testDriveStep1":
    "Escolha a data disponível no calendário — sem horário marcado, é o dia inteiro.",
  "schedule.testDriveStep2":
    "A Woba confirma a disponibilidade direto com o espaço.",
  "schedule.testDriveStep3":
    "Você recebe a confirmação e leva seu time no dia combinado.",
  "schedule.testDriveStep4":
    "Decide com base na experiência real, não só em fotos.",
  "schedule.testDriveBenefitsTitle": "O que você ganha",
  "schedule.testDriveBenefit1":
    "Testa a rotina do seu time no espaço antes de fechar.",
  "schedule.testDriveBenefit2": "Sem custo — a visita é por conta da Woba.",
  "schedule.testDriveBenefit3":
    "Mais segurança para decidir, com dados reais do dia a dia.",
  "schedule.testDriveClosingNote":
    "* Sujeito à confirmação do espaço, dentro do horário de funcionamento dele.",
  "schedule.testDriveNoteLabel": "Por que você quer testar esse espaço?",
  "schedule.testDriveNotePlaceholder":
    "Conte o que chamou sua atenção nesse escritório e o que quer confirmar com o test-drive",
  "schedule.testDriveSingleRoomError":
    "Test-drive é só para 1 escritório por vez. Remova os outros para continuar.",
  "schedule.visitorCountLabel": "Quantas pessoas vão à visita?",
  "schedule.visitorCountPlaceholder": "Ex: 4 pessoas",
  "schedule.valueBullet1":
    "Melhor preço garantido — o mesmo que negociando direto.",
  "schedule.valueBullet2": "Ganhe créditos para salas de reunião e coworking.",
  "schedule.valueBullet3":
    "Flexibilidade para aumentar, reduzir ou mudar de cidade.",
  "schedule.visitTypeInPerson": "Visita presencial",
  "schedule.visitTypeOnline": "Visita por videochamada",
  "schedule.visitTypeTestDrive": "Test-drive (1 dia)",
  "schedule.slotTakenHint": "Esse horário já foi escolhido para outro espaço",
  "schedule.fewSlotsAlert":
    "Poucos horários disponíveis. Escolha o seu e garanta a sua visita.",
  "schedule.confirm": "Solicitar visita",
  "schedule.subStepAriaLabel": "Etapas do agendamento",
  "schedule.subStepWhen": "Dia e horário",
  "schedule.subStepData": "Seus dados",
  "schedule.dataOverline": "Quase lá",
  "schedule.dataTitle": "Quem vai *participar*?",
  "schedule.dataSubtitle":
    "Complete os dados de quem vai participar da visita.",
  "schedule.hintIncomplete":
    "Selecione dia, horário e formato para cada espaço",
  "schedule.hintContactIncomplete": "Preencha os campos para continuar",
  "schedule.fieldEmail": "E-mail",
  "schedule.fieldEmailPlaceholder": "seu@email.com",
  "schedule.fieldEmailError": "Preencha um e-mail válido",
  "schedule.fieldWhatsappError": "Preencha adequadamente o número de telefone",
  "schedule.addAnotherSpace": "Incluir outro espaço na visita",
  "schedule.addParticipant": "Incluir outro participante",
  "schedule.removeVisit": "Remover este espaço da visita",
  "schedule.removeParticipant": "Remover participante",
  "schedule.participantLabel": "Participante {{n}}",
  "schedule.fieldName": "Nome",
  "schedule.fieldNamePlaceholder": "Seu nome",
  "schedule.fieldJobTitle": "Cargo",
  "schedule.fieldJobTitlePlaceholder": "Seu cargo",
  "schedule.fieldWhatsapp": "WhatsApp (recomendado)",
  "schedule.fieldWhatsappRequired": "WhatsApp",
  "schedule.fieldWhatsappPlaceholder": "(11) 90000-0000",
  "schedule.fieldCpf": "CPF",
  "schedule.fieldCpfPlaceholder": "000.000.000-00",
  "schedule.fieldCpfError": "Preencha um CPF válido",
  "schedule.fieldCpfHint":
    "Usado só para liberar seu acesso ao espaço no dia do test-drive.",
  "privacy.consentPrefix":
    "Ao enviar este formulário, você declara estar ciente da nossa",
  "privacy.consentLinkLabel": "Política de Privacidade",
  "privacy.consentSuffix":
    ". Seus dados serão utilizados para viabilizar o atendimento solicitado.",
  "schedule.successTitle": "Solicitação enviada!",
  "schedule.successSubtitle":
    "Sua solicitação foi enviada. Fique de olho no seu e-mail: avisamos assim que o parceiro confirmar o horário.",
  "schedule.successNotice":
    "As condições da sua proposta estão garantidas até {{date}}.",
  "schedule.fullAddressNotice": "Endereço completo enviado na confirmação.",
  "schedule.postStep0Label": "Solicitação enviada",
  "schedule.postStep0Time": "Concluído",
  "schedule.toBeConfirmed": "a confirmar",
  "schedule.postStep1Label": "Visitar escritório",
  "schedule.postStep2Label": "Proposta final",
  "schedule.postStep3Label": "Assine e ocupe",
  "schedule.postStep1Time": "A partir de 48h",
  "schedule.postStep2Time": "48h após visita",
  "schedule.postStep3Time": "Até 15 dias",
  "schedule.confirmationOverline": "Próximos passos",
  "schedule.confirmationTitle": "Do interesse à operação, *em poucos dias*.",
  "schedule.confirmationSubtitle":
    "Acompanhe o que vem a seguir até você ocupar o novo escritório.",
  "schedule.recapOverline": "Rede Woba",
  "schedule.recapHeading":
    "Você contrata um escritório.\nLeva um país inteiro.",
  "schedule.recapSubheading":
    "5% do valor do seu contrato vira bônus em créditos, pra sua equipe não ficar presa a um único endereço. Ela pode usar salas de reunião, estações de trabalho e espaços de evento em qualquer cidade do Brasil.",
  "schedule.recapPricePre": "E o preço?",
  "schedule.recapPriceBold":
    "Sempre o mesmo que você pagaria negociando direto",
  "schedule.recapPricePost": "— sem custo extra.",
  "schedule.recapStat1Value": "+3.000",
  "schedule.recapStat1Label": "escritórios flexíveis",
  "schedule.recapStat2Value": "+4.200",
  "schedule.recapStat2Label": "salas de reunião",
  "schedule.recapStat3Value": "+1.000",
  "schedule.recapStat3Label": "espaços de eventos",
  "schedule.recapStat4Value": "+400",
  "schedule.recapStat4Label": "cidades na LatAm",
  "schedule.recapType1Title": "Estações de Trabalho",
  "schedule.recapType1DescPre": "1 diária em qualquer uma das",
  "schedule.recapType1DescCount": "+23.000",
  "schedule.recapType1DescPost": "estações",
  "schedule.recapType2Title": "Salas de Reunião",
  "schedule.recapType2DescPre": "1 hora em qualquer uma das",
  "schedule.recapType2DescCount": "+4.200",
  "schedule.recapType2DescPost": "salas",
  "schedule.recapType3Title": "Espaços de Eventos",
  "schedule.recapType3DescPre": "1 diária em qualquer um dos",
  "schedule.recapType3DescCount": "+1.000",
  "schedule.recapType3DescPost": "espaços",
  "schedule.recapType4Title": "Escritórios Privativos",
  "schedule.recapType4DescPre": "1 mês em qualquer um dos",
  "schedule.recapType4DescCount": "+5.200",
  "schedule.recapType4DescPost": "escritórios",
  "schedule.recapCredits": "créditos",
  "schedule.recapCreditsPerPerson": "créditos/pessoa",
  "schedule.recapCreditsPerPosition": "créditos/posição",

  // ── Spaces (additional) ──
  "spaces.option": "Escritório Privativo {{number}}",
  "spaces.ofTotal": "de {{total}}",

  // ── POI Categories ──
  "poi.restaurant": "Restaurantes",
  "poi.cafe": "Cafés",
  "poi.pharmacy": "Farmácias",
  "poi.transport": "Transporte",
  "poi.hotel": "Hotéis",
  "poi.parking": "Estacionamentos",

  // ── Chat (additional) ──
  "chat.defaultSpaceName": "este espaço",

  // ── CreditInfoDrawer ──
  "creditDrawer.viewDetails": "Ver detalhes dos créditos",
  "creditDrawer.title": "Créditos inclusos na sua contratação",
  "creditDrawer.subtitle":
    "5% do valor do seu contrato vira bônus em créditos.",
  "creditDrawer.creditsLabel": "Créditos/mês inclusos*",
  "creditDrawer.creditsValue": "+{{credits}} créditos",
  "creditDrawer.creditsFootnote":
    "* Os créditos não são cumulativos: o que não for usado no mês não passa para o mês seguinte.",
  "creditDrawer.howItWorksBody":
    "Sua equipe não fica presa a este endereço: com os créditos inclusos, ela pode usar salas de reunião, estações de trabalho e espaços de evento em qualquer cidade do Brasil — sem gastar nada a mais por isso.",
  "creditDrawer.formatMeetingRoomTitle": "Salas de reunião",
  "creditDrawer.formatMeetingRoomBody":
    "{{credits}} créditos equivalem a {{hours}}h de sala de reunião para até 4 pessoas — o valor muda conforme o tamanho da sala.",
  "creditDrawer.formatCoworkingTitle": "Coworking (estações compartilhadas)",
  "creditDrawer.formatCoworkingBody":
    "{{credits}} créditos equivalem a {{credits}} diárias de uso em espaços compartilhados.",
  "creditDrawer.formatPrivateOfficeTitle": "Escritórios privativos por diária",
  "creditDrawer.formatPrivateOfficeBody":
    "Use créditos para montar estruturas temporárias para projetos ou times.",
  "creditDrawer.formatEventSpaceTitle": "Espaços para eventos e treinamentos",
  "creditDrawer.formatEventSpaceBody":
    "Reserve salas maiores e auditórios usando múltiplos créditos.",
  "creditDrawer.quadroHoursLabel": "por mês",
  "creditDrawer.quadroDaysLabel": "diárias/mês",
  "creditDrawer.onRequest": "Sob consulta",
  "creditDrawer.practiceTitle": "Na prática",
  "creditDrawer.practiceDayToDayTitle": "Como isso se aplica no seu dia a dia",
  "creditDrawer.practiceBullet1":
    "Seu escritório deixa de ser um único endereço",
  "creditDrawer.practiceBullet2":
    "Você escolhe o formato certo pra cada momento, sem precisar de contrato novo",
  "creditDrawer.practiceBullet3":
    "O crédito já está incluso — não é custo extra no seu boleto",
  "creditDrawer.practiceCta":
    "Em vez de contratar mais espaço, você usa créditos quando precisa.",

  // ── CreditInfoDrawer, variante "créditos extras" (ENT, PED-12653) ──
  "extraCreditDrawer.viewDetails": "Ver detalhes dos créditos extras",
  "extraCreditDrawer.title": "Créditos extras na sua contratação",
  "extraCreditDrawer.subtitle":
    "Um pacote opcional de créditos, além dos inclusos, para usar na rede Woba.",
  "extraCreditDrawer.creditsLabel": "Créditos extras/mês*",
  "extraCreditDrawer.monthlyValueLabel": "Valor do pacote/mês",
  "extraCreditDrawer.howItWorksBody":
    "Além dos créditos inclusos, este pacote dá à sua equipe mais créditos por mês para usar salas de reunião, estações de trabalho e espaços de evento em qualquer cidade do Brasil — e ele entra no seu total mensal.",
  "extraCreditDrawer.practiceBullet3":
    "O pacote é opcional e entra no seu total mensal — sem contrato à parte",

  // ── RoomPriceCard (card de preço no drawer de detalhes, desktop) ──
  "priceCard.monthlyLabel": "Mensalidade do escritório",
  "priceCard.monthlyLabelWithScope": "Mensalidade - {{scope}}",
  "priceCard.perPositionValue": "{{price}} / posição",

  // ── PriceGuaranteeModal ──
  "priceGuarantee.title": "Garantia de melhor preço",
  "priceGuarantee.subtext": "Mesmo preço do parceiro, com até 15% de desconto",
  "priceGuarantee.bodyPre":
    "Negociamos direto com o parceiro pra garantir o melhor preço da sua proposta. Conseguimos ",
  "priceGuarantee.bodyBold": "até 15% de desconto",
  "priceGuarantee.bodyPost": " sobre o valor do escritório.",
  "priceCard.creditsLabel": "Créditos inclusos",
  "priceCard.freeBadge": "grátis",
  "priceCard.creditsSubtext":
    "Equivalente a {{credits}} diárias de escritório/mês",
  "priceCard.flexCreditsLabel": "Créditos extras (opcional)",
  "priceCard.setupFeeLabel": "Setup Fee",
  "priceCard.setupFeeCaption": "Pago uma única vez",
  "priceCard.licenseFeeLabel": "License Fee",
  "priceCard.licenseFeeSemiannualCaption": "Pago semestralmente",
  "priceCard.licenseFeeAnnualCaption": "Pago anualmente",
  "priceCard.helpLink": "Ainda tem dúvidas? Fale com a gente",
  "priceCard.scheduleVisit": "Solicitar visita",
  "priceCard.makeProposal": "Fazer proposta",

  // ── ProposalMakingStep (fluxo "Fazer proposta") ──
  // Mesmo padrão de eyebrow + título com ênfase + subtítulo do
  // VisitSchedulingStep — "Fazer proposta" lê como a mesma jornada, só um
  // caminho diferente.
  "proposalMaking.hub.overline": "Faça sua proposta",
  "proposalMaking.hub.headline": "Você *decide* como avançar.",
  "proposalMaking.hub.subtitle":
    "Revise os valores e o resumo da sala antes de escolher os próximos passos para a {{companyName}}.",
  "proposalMaking.hub.subtitleNoCompany":
    "Revise os valores e o resumo da sala antes de escolher os próximos passos.",
  "proposalMaking.subStepDefine": "Condições da proposta",
  "proposalMaking.subStepAdjust": "Ajuste de preço e do espaço",
  "proposalMaking.subStepReview": "Identificação",
  "proposalMaking.subStepAriaLabel": "Etapas da proposta",
  "proposalMaking.choose.pickerLabel": "Escolha uma opção",
  "proposalMaking.choose.acceptLabel": "Aceitar condições",
  "proposalMaking.choose.acceptDescription":
    "Aceitar as condições atuais agiliza a análise e coloca sua proposta na frente de quem está negociando.",
  "proposalMaking.choose.negotiateLabel": "Negociar valor ou pedir ajuste",
  "proposalMaking.choose.negotiateDescription":
    "Proponha um valor diferente ou peça ajustes no espaço — nosso time avalia e responde em até 2 dias úteis.",
  "proposalMaking.negotiate.overline": "Negociar valor",
  "proposalMaking.negotiate.headline": "Proponha o valor *ideal* pra você.",
  "proposalMaking.negotiate.subtitle":
    "Ajuste o valor mensal proposto e conte pro nosso time por que ele faz sentido pra você — quanto mais próximo do valor atual, maior a chance de aceite rápido pelo parceiro.",
  "proposalMaking.negotiate.subtitleNoPrice":
    "Conte pro nosso time o que você gostaria de propor e por que faz sentido pra você — ele avalia junto com o parceiro e responde em seguida.",
  "proposalMaking.negotiate.sectionTitle": "Ajuste de preço",
  "proposalMaking.negotiate.fieldLabel": "Sua proposta",
  "proposalMaking.negotiate.fieldPlaceholder": "0",
  "proposalMaking.negotiate.goodProposalTitle": "Ótima proposta!",
  "proposalMaking.negotiate.goodProposalDescription":
    "Valor igual ou maior que o atual tem alta chance de ser aceito.",
  "proposalMaking.negotiate.moderateDiscountTitle": "Boa chance de aceite",
  "proposalMaking.negotiate.moderateDiscountDescription":
    "Descontos de até 15% têm boas chances de ser aprovados pelo parceiro.",
  "proposalMaking.negotiate.highDiscountTitle": "Desconto alto",
  "proposalMaking.negotiate.highDiscountDescription":
    "Descontos acima de 15% são mais difíceis de aprovar — a resposta pode demorar mais.",
  "proposalMaking.negotiate.discountBadge": "-{{percent}}%",
  "proposalMaking.negotiate.increaseBadge": "+{{percent}}%",
  "proposalMaking.negotiate.reasonLabel": "Conte o motivo da sua proposta",
  "proposalMaking.negotiate.reasonPlaceholder":
    "Conte pra gente o motivo do ajuste de valor...",
  "proposalMaking.negotiate.flexCreditsLabel": "Créditos extras por mês",
  "proposalMaking.negotiate.flexCreditsUnit": "créditos",
  "proposalMaking.negotiate.flexCreditsHelper":
    "Equivale a {{value}}/mês. A negociação acima vale apenas para a mensalidade.",
  "proposalMaking.adjustmentsChoice.pickerLabel":
    "Ajuste de configurações do espaço",
  "proposalMaking.adjustmentsChoice.overline": "Ajustes no espaço",
  "proposalMaking.adjustmentsChoice.headline": "Precisa de algum *ajuste*?",
  "proposalMaking.adjustmentsChoice.subtitle":
    "Você pode pedir para retirar, instalar, reparar ou substituir item.",
  "proposalMaking.adjustmentsChoice.noneLabel": "Sem ajustes",
  "proposalMaking.adjustmentsChoice.noneBadge": "Maior chance de ser aceita",
  "proposalMaking.adjustmentsChoice.someLabel": "Com ajustes",
  "proposalMaking.adjustmentsChoice.someBadge": "Sujeito à avaliação do espaço",
  "proposalMaking.adjustmentType.overline": "Tipo de ajuste",
  "proposalMaking.adjustmentType.headline": "Qual é o tipo do *ajuste*?",
  "proposalMaking.adjustmentType.subtitle":
    "Você pode adicionar um ajuste por vez.",
  "proposalMaking.adjustmentType.layout": "Layout",
  "proposalMaking.adjustmentType.layoutDescription":
    "Retirar ou instalar um item, mudar ou substituir algo no espaço.",
  "proposalMaking.adjustmentType.maintenance": "Manutenção ou reparo",
  "proposalMaking.adjustmentType.maintenanceDescription":
    "Consertar ou fazer manutenção em algo que já existe.",
  "proposalMaking.adjustmentType.positions": "Posições",
  "proposalMaking.adjustmentType.positionsDescription":
    "Aumentar ou reduzir o número de posições do escritório.",
  "proposalMaking.adjustmentDescription.overline": "Detalhe o ajuste",
  "proposalMaking.adjustmentDescription.headline":
    "Descreva o que você *precisa*.",
  "proposalMaking.adjustmentDescription.subtitle":
    "Quanto mais detalhes, mais rápido avaliamos o pedido.",
  "proposalMaking.adjustmentDescription.placeholder":
    "Descreva o que você precisa...",
  "proposalMaking.adjustmentDescription.continueLabel": "Revisar",
  "proposalMaking.review.overline": "Quase lá",
  "proposalMaking.review.headline": "Revise sua *proposta*.",
  "proposalMaking.review.subtitle":
    "Confirme os valores e ajustes antes de enviar pro nosso time.",
  "proposalMaking.review.bannerAccepted": "Essa é uma ótima proposta!",
  "proposalMaking.review.bannerNegotiating":
    "Sua proposta será enviada para análise do nosso parceiro.",
  "proposalMaking.review.adjustmentsTitle": "Ajustes solicitados",
  "proposalMaking.review.addAdjustment": "Adicionar ajuste",
  "proposalMaking.review.removeAdjustment": "Remover",
  "proposalMaking.review.identificationTitle": "Seus dados",
  "proposalMaking.review.occupancyDateLabel": "Data prevista de ocupação",
  "proposalMaking.review.contractTermLabel": "Prazo de contrato",
  "proposalMaking.review.contractTermOption.12": "12 meses",
  "proposalMaking.review.contractTermOption.24": "24 meses",
  "proposalMaking.review.contractTermOption.36": "36 meses",
  "proposalMaking.review.contractTermOption.48": "48 meses",
  "proposalMaking.review.contractTermOption.other": "Outro",
  "proposalMaking.review.contractTermCustomPlaceholder": "Quantos meses?",
  "proposalMaking.review.submitLabel": "Confirmar e enviar",
  "proposalMaking.sent.overline": "Próximos passos",
  "proposalMaking.sent.headline": "Proposta enviada!",
  "proposalMaking.sent.subtitle": "Sua proposta foi enviada para o time Woba.",
  "proposalMaking.sent.notice": "Essa proposta é válida até {{date}}.",
  "proposalMaking.sent.roomStatusLabel": "Proposta enviada",
  "proposalMaking.sent.postStep0Label": "Proposta enviada",
  "proposalMaking.sent.postStep0Time": "Concluído",
  "proposalMaking.sent.postStep1Label": "Em análise",
  "proposalMaking.sent.postStep1Time": "Resposta em até 2 dias úteis",
  "proposalMaking.sent.postStep2Label": "Aprovação",
  "proposalMaking.sent.postStep2Time": "Após retorno do parceiro",
  "proposalMaking.sent.postStep3Label": "Assine e ocupe",
  "proposalMaking.sent.postStep3Time": "Até 15 dias",

  // ── Card "Sob Medida" (PED-13464) + fluxo de briefing ──
  "customOffice.card.title":
    "Prefere um escritório\nsob medida para\na sua empresa?",
  "customOffice.card.subtitle":
    "Podemos ir além destas opções. Se você quer algo mais exclusivo, montamos um escritório sob medida, sem você precisar lidar com imobiliária, obra e fornecedores.",
  "customOffice.card.bullet1": "Encontramos a laje ideal",
  "customOffice.card.bullet2": "Projeto 100% personalizado",
  "customOffice.card.bullet3": "Operação completa inclusa",
  "customOffice.card.bullet4": "Todos os benefícios Woba",
  "customOffice.card.cta": "Montar meu escritório",
  // Qualifica antes do clique (receio do time: cliente entrar achando que
  // é mais uma sala pronta): projeto exclusivo, investimento maior. Sem
  // número, porque não há faixa segura para prometer.
  "customOffice.card.footnote":
    "Projeto exclusivo · Investimento acima de um escritório pronto",
  // Fluxo de briefing — as 5 perguntas da referência "Briefing rápido ·
  // Camada 1", com o texto reescrito para um formulário que o
  // cliente responde sozinho dentro da proposta: sem jargão interno, sem
  // abreviação, cada campo se explica.
  "customOffice.hub.overline": "Escritório sob medida · 3 etapas",
  "customOffice.hub.headline": "Vamos desenhar o *lugar* do seu time",
  "customOffice.hub.subtitle":
    "Responda cinco perguntas rápidas sobre o que o seu time precisa e deixe seus dados de contato. Leva uns 10 minutos e já é o suficiente para a Woba começar a buscar o espaço ideal para você.",
  // Bloco honesto antes das perguntas: o que é, por que custa mais e demora
  // mais, e a saída elegante para quem só queria mais opções prontas.
  "customOffice.hub.noticeTitle": "Antes de começar",
  "customOffice.hub.noticeBody":
    "O sob medida é um projeto exclusivo: encontramos o imóvel, desenhamos o escritório para o seu time e cuidamos da operação. Por isso, o investimento costuma ficar acima de um escritório pronto, e a entrada leva mais tempo, porque pode haver obra. Se um escritório pronto atende, ele continua sendo o caminho mais rápido e econômico.",
  "customOffice.hub.previewTitle": "O que você vai responder",
  "customOffice.hub.footnote":
    "Depois de enviar, nosso time entra em contato para combinar os detalhes.",
  "customOffice.stepper.ariaLabel": "Etapas do formulário",
  // 3 etapas: o espaço (perguntas 01 e 02), time e prioridades (03 a 05)
  // e "Seus dados" sozinho — cada pergunta segue como um card próprio.
  "customOffice.stepper.place": "O espaço",
  "customOffice.stepper.routine": "Time e prioridades",
  "customOffice.stepper.contact": "Seus dados",
  "customOffice.stage.overline": "Etapa {{number}} de {{total}}",
  "customOffice.stage.place.title": "Como é o escritório ideal?",
  "customOffice.stage.place.subtitle":
    "Onde ele fica, para quantas pessoas e que tipo de imóvel você procura.",
  "customOffice.stage.routine.title": "Como o seu time vai usar o espaço?",
  "customOffice.stage.routine.subtitle":
    "O dia a dia, o que não pode faltar e referências que ajudam a acertar.",
  "customOffice.stage.contact.title": "Seus dados",
  "customOffice.stage.contact.subtitle":
    "Para quem devemos retornar com a proposta sob medida.",
  "customOffice.q1.title": "Onde e para quantos?",
  "customOffice.q1.subtitle":
    "Onde o escritório deve ficar, para quantas pessoas e para quando.",
  "customOffice.q1.regionLabel": "Cidade e região / bairro desejado",
  "customOffice.q1.regionPlaceholder":
    "Ex.: São Paulo, Pinheiros ou Faria Lima",
  "customOffice.q1.peopleLabel": "Número de pessoas",
  "customOffice.q1.peoplePlaceholder": "Ex.: 20",
  "customOffice.q1.sizeLabel": "Metragem aproximada (m²)",
  "customOffice.q1.sizePlaceholder": "Se souber. Ex.: 200",
  "customOffice.q1.deadlineLabel": "Prazo para entrar",
  "customOffice.q1.deadlinePlaceholder": "Ex.: em 60 dias, até março",
  "customOffice.requiredHint": "Preencha os campos obrigatórios para continuar",
  "customOffice.q2.title": "Como é o lugar ideal?",
  "customOffice.q2.subtitle":
    "O padrão do prédio, o tipo de imóvel e se você precisa de vagas.",
  "customOffice.q2.standardLabel": "Padrão desejado",
  "customOffice.q2.standardOption.premium": "Alto padrão (AAA)",
  "customOffice.q2.standardOption.intermediate": "Intermediário",
  "customOffice.q2.standardOption.simple": "Mais simples",
  "customOffice.q2.buildingTypeLabel": "Tipo de imóvel",
  "customOffice.q2.buildingTypeOption.corporateSlab":
    "Laje em prédio corporativo",
  "customOffice.q2.buildingTypeOption.streetBuilding": "Casa ou imóvel de rua",
  "customOffice.q2.buildingTypeOption.either": "Tanto faz",
  "customOffice.q2.parkingLabel": "Estacionamento",
  "customOffice.q2.parkingPlaceholder": "Quantas vagas você precisa? Ex.: 5",
  "customOffice.q2.readinessLabel":
    "Você prefere um escritório pronto ou aceita fazer obra?",
  "customOffice.q2.readinessOption.readyToUse": "Pronto para usar",
  "customOffice.q2.readinessOption.openToCustomBuild":
    "Aceito uma obra sob medida",
  "customOffice.q3.title": "Como é o dia a dia do time?",
  "customOffice.q3.subtitle": "Quantas salas de reunião o time precisa.",
  "customOffice.q3.meetingSmallLabel": "Pequenas (até 4 pessoas)",
  "customOffice.q3.meetingSmallPlaceholder": "Quantas?",
  "customOffice.q3.meetingMediumLabel": "Médias (6 a 8 pessoas)",
  "customOffice.q3.meetingMediumPlaceholder": "Quantas?",
  "customOffice.q3.meetingLargeLabel": "Grandes (10 ou mais)",
  "customOffice.q3.meetingLargePlaceholder": "Quantas?",
  "customOffice.q3.meetingRoomsLabel": "Salas de reunião",
  "customOffice.q4.title": "O que é prioridade?",
  "customOffice.q4.subtitle":
    "As comodidades básicas, o que não pode faltar de jeito nenhum e o que seria bom ter.",
  // As comodidades vieram da pergunta 03 (é escolha de
  // prioridade, não rotina). Os exemplos de "não pode faltar" precisam ser
  // coisas que os chips não cobrem, senão o cliente repete a lista.
  "customOffice.q4.amenitiesLabel": "Comodidades básicas obrigatórias",
  "customOffice.q4.amenitiesOption.kitchen": "Copa ou refeitório",
  "customOffice.q4.amenitiesOption.buildingReception": "Recepção no prédio",
  "customOffice.q4.amenitiesOption.publicTransport":
    "Transporte público por perto",
  "customOffice.q4.amenitiesOption.restaurants": "Restaurantes por perto",
  "customOffice.q4.nonNegotiableLabel": "O que mais não pode faltar",
  "customOffice.q4.nonNegotiableHelp":
    "Cite um item por linha, começando pelo mais importante. Exemplos: aceitar pets, certificação ambiental do prédio, área de carga e descarga, sala segura, recepção 24 horas.",
  "customOffice.q4.priority1Label": "1º",
  "customOffice.q4.priority2Label": "2º",
  "customOffice.q4.priority3Label": "3º",
  "customOffice.q4.niceToHaveLabel": "Seria bom ter",
  "customOffice.q4.niceToHaveHelp":
    "Opcional. Itens que fariam diferença, mas não decidem a escolha.",
  "customOffice.q4.niceToHavePlaceholder":
    "Ex.: bicicletário, academia no prédio, terraço",
  "customOffice.q5.title": "Já viu algum imóvel de que gostou?",
  "customOffice.q5.subtitle":
    "Exemplos do que você gostou ou descartou ajudam a acertar mais rápido.",
  "customOffice.q5.likedLabel":
    "Algum escritório ou prédio que você viu e gostou? Conte o que pesou: endereço, prédio, planta, preço.",
  "customOffice.q5.likedPlaceholder":
    "Ex.: o prédio X na Faria Lima, pela localização e pela planta",
  "customOffice.q5.discardedLabel": "Algum que você descartou? Por quê?",
  "customOffice.q5.discardedPlaceholder":
    "Ex.: o prédio Y, porque não tinha estacionamento",
  // Última etapa: os mesmos 4 campos de identificação da proposta
  // ("Seus dados" na revisão), reaproveitando o ContactForm e seus rótulos.
  "customOffice.contact.hint": "Preencha seus dados para enviar",
  "customOffice.submitLabel": "Enviar respostas",
  "customOffice.sent.overline": "Próximos passos",
  // Tela final igual à da visita/proposta: stepper do que vem depois, card
  // resumo do que foi pedido e a proposta de valor da rede abaixo.
  "customOffice.sent.summaryLabel": "Respostas enviadas",
  "customOffice.sent.postStep0Label": "Respostas enviadas",
  "customOffice.sent.postStep0Time": "Concluído",
  "customOffice.sent.postStep1Label": "Busca de imóveis",
  "customOffice.sent.postStep1Time": "Em até 7 dias",
  "customOffice.sent.postStep2Label": "Proposta sob medida",
  "customOffice.sent.postStep2Time": "Após a busca",
  "customOffice.sent.postStep3Label": "Assine e ocupe",
  "customOffice.sent.postStep3Time": "Prazo a combinar",
  "customOffice.summary.likedLabel": "Gostou",
  "customOffice.summary.discardedLabel": "Descartou",
  "customOffice.sent.headline": "Respostas enviadas!",
  "customOffice.sent.subtitle":
    "Nosso time vai usar suas respostas para montar uma proposta sob medida. Você recebe em até 7 dias.",

  // ── Rating (avaliação da recomendação) ──
  "rating.prompt": "Acertamos na escolha?",
  "rating.drawerPrompt": "Acertamos na escolha desse escritório?",
  "rating.thumbUp": "Gostei deste escritório",
  "rating.thumbDown": "Não gostei deste escritório",
  "rating.modalTitlePositive": "Boa! Acertamos na recomendação",
  "rating.modalTitleNegative": "Ainda não acertamos na recomendação",
  "rating.modalSupportPositive":
    "Sua avaliação ajuda a gente a entender o que fez sentido pra você.",
  "rating.modalSupportNegative":
    "Temos mais opções pra você. Sua avaliação ajuda a gente a trazer as mais certeiras.",
  "rating.questionNegative": "O que não encaixou?",
  "rating.questionPositive": "O que você mais gostou?",
  "rating.subReasonsLabel": "O que está faltando?",
  "rating.commentLabel": "Quer contar mais? (opcional)",
  "rating.commentPlaceholder": "Escreva aqui...",
  "rating.submit": "Enviar avaliação",
  "rating.confirmationTitle": "Recebido!",
  "rating.confirmationBody":
    "Vamos usar sua avaliação para melhorar as próximas sugestões.",
  "rating.close": "Fechar",
  "rating.reason.photos": "As fotos não ajudam a entender o escritório",
  "rating.reason.capacity": "Não comporta o número de pessoas que eu preciso",
  "rating.reason.location": "A região não funciona pra mim",
  "rating.reason.price": "Não vale o valor pedido",
  "rating.reason.layoutCondition":
    "O layout ou o estado do escritório não me agradou",
  "rating.reason.missingRequirements": "Falta algo que eu preciso",
  "rating.reason.capacityFit": "Comporta bem o meu time",
  "rating.reason.locationGreat": "A região é ótima pra mim",
  "rating.reason.visualAppeal": "Gostei do visual do escritório",
  "rating.reason.amenitiesComplete": "Tem tudo o que eu preciso",
  "rating.reason.priceValue": "Bom custo-benefício",
  "rating.subReason.amenities": "Amenidades",
  "rating.subReason.equipment": "Equipamentos",
  "rating.subReason.accessibility": "Acessibilidade",
  "rating.subReason.other": "Outras características",
};
